<ion-grid>
  <ion-row class="ion-justify-content-end ion-align-items-center margin-bottom-m">
    <ion-button class="close-button" color="getm-background-light-blue" (click)="onDismiss()" fill="solid"
      shape="round">
      <ion-icon name="getm-close" class="close-icon" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-row>
  <ion-row class="margin-bottom-m">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="leave-promo-title">
        {{ 'Modals.leave-promo-detail.title' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row class="margin-bottom-xl">
    <ion-col class="ion-no-padding ion-text-center" size="12">
      <ion-text class="leave-promo-body">
        {{ 'Modals.leave-promo-detail.text' | translate }}
      </ion-text>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="ion-no-padding buttons-container" size="12">
      <getm-button [text]="'Modals.leave-promo-detail.confirmButton' | translate" color="tertiary" size="large" expand="block" (click)="onConfirm()"></getm-button>
      <getm-button [text]="'Modals.leave-promo-detail.cancelButton' | translate" color="primary" size="large" expand="block" (click)="onDismiss()"></getm-button>
    </ion-col>
  </ion-row>
</ion-grid>
